import { StorageService } from './Common/storage.service';
import {
  AuthTokenFactory,
  AuthTokenService
} from './auth/auth-token.service';
import { AuthService } from './auth/auth.service';
import { TokenInterceptor } from './interceptors/token.interceptor';
import { JsonApiService } from './Common/json-api.service';
import { UserService } from './Common/user.service';
import { ChatService } from './Common/chat.service';
import { NotificationService } from './Common/notification.service';
import { BodyService } from './Common/body.service';
import { LayoutService } from './Common/layout.service';
import { SoundService } from './Common/sound.service';


import * as fromVoice from './voice';
import { AuthorizeService  } from './auth/authorize.service';
import { AESEncryptDecryptService } from './Common/aesencrypt-decrypt.service';

export const services = [
  StorageService,
  AuthTokenService,
  AuthService,
  //AuthorizeService,
  TokenInterceptor,

  JsonApiService,
  UserService,
  ChatService,
  NotificationService,
  BodyService,
  LayoutService,
  SoundService,
  fromVoice.VoiceControlService,
  fromVoice.VoiceRecognitionService,
  AESEncryptDecryptService
];

export * from './Common/storage.service';
export * from './auth/auth-token.service';
export * from './auth/auth.service';
export * from './interceptors/token.interceptor';
export * from './Common/json-api.service';
export * from './Common/user.service';
export * from './Common/chat.service';
export * from './Common/notification.service';
export * from './Common/body.service';
export * from './Common/layout.service';
export * from './Common/sound.service';
export * from './voice';
export * from './Common/aesencrypt-decrypt.service';
